<template>
  <b-modal id="modal-api" title="Change API Key" :ok-title="okTitle" :ok-only="success" @show="resetModal" @ok="changeApi">

    <div>
      <div v-if="!success">
        <b-form @submit.prevent="changeApi">
          <b-form-group
            id="api-group"
            label="API Key"
            label-for="apiKey"
          >
            <b-form-input
              id="apiKey"
              v-model="apiKey"
              type="text"

            ></b-form-input>
          </b-form-group>

        </b-form>
        <div>
          <b-alert :show="error" variant="danger">{{ errorMessage }}</b-alert>
        </div>
      </div>
      <div v-if="success">
        <b-alert :show="success" variant="success">{{ message }}</b-alert>

      </div>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: 'change-api-key',

  data () {
    return {
      message: '',
      errorMessage: '',
      apiKey: '',
      error: false,
      success: false
    }
  },
  computed: {
    okTitle: function () {
      return this.success ? 'OK' : 'Change API Key'
    }
  },
  methods: {
    resetModal (evt) {
      this.success = false
      this.error = false
      this.$http.get('/api/currentApiKey').then((response) => {
        console.log('received data ' + response.data)
        this.apiKey = response.data
      })
    },
    changeApi (evt) {
      this.error = false
      if (!this.success) {
        evt.preventDefault()

        this.$http.post('/api/changeApiKey', this.apiKey).then((response) => {
          console.log('received msg ' + response.data.message)
          this.message = response.data.message
          this.success = true
          this.okTitle = 'OK'
        }).catch((err) => {
          console.log('error catched')
          if (err.response) {
            // Request made and server responded
            console.log(err.response.data)
            console.log(err.response.status)
            console.log(err.response.headers)
            this.error = true
            this.errorMessage = err.response.data.message
          } else if (err.request) {
            this.error = true
            this.errorMessage = 'Could not perform request'
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message)
            this.error = true
            this.errorMessage = 'Could not perform request'
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ChangeApiKey.vue